import type {ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import type {ReactElement} from 'react';

export interface ShareInTeamToggleBarProps {
  state: ShareInTeamBarState;
  onStateUpdate: (state: ShareInTeamBarState) => void;
  isCurrentlyLoading?: boolean;
  customClasses?: string;
  toggleSize?: ToggleSwitchV2Size;
  shareInTeamIcon?: ReactElement<any>;
}

export enum ShareInTeamBarState {
  ACTIVE = 1,
  INACTIVE = 2,
  UPSELLING = 3,
}
